var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sec-card",style:({
    flexFlow: _vm.reverse ? 'row-reverse nowrap' : false,
  })},[_c('img',{staticClass:"sec-card__img",attrs:{"src":_vm.img,"alt":""}}),_c('div',{staticClass:"sec-card__content"},[_c('span',{staticClass:"sec-card__caption"},[_vm._t("caption")],2),_c('h2',{staticClass:"sec-card__title"},[_vm._t("title")],2),_c('p',{staticClass:"sec-card__text"},[_vm._t("text")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }